module.exports = __webpack_public_path__ + "img/w3.78eff1c1.png";